export default function getLanguageFromCode(languageCode: string) {
  switch (languageCode) {
    case 'es':
      return 'Castellano'
    case 'ca':
      return 'Catalán'
    case 'gl':
      return 'Gallego'
    case 'eu':
      return 'Euskera'
    case 'en':
      return 'Inglés'
    case 'pt':
      return 'Portugués'
    default:
      return '-'
  }
}
